/**************************************************
 * Nombre:       Tarjeta_Check_Texto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {CheckCircleOutline} from "@mui/icons-material";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Check_Texto = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={1} sx={{justifyContent: 'flex-start'}}>
                <CheckCircleOutline sx={{fill: theme.palette.secondary.main, width: 32, height: 32}}/>
            </Grid>

            <Grid container size={11} sx={{justifyContent: 'flex-start', pl: sCell ? 2 : 0}}>
                <Typography sx={{color: theme.palette.primary.main, fontSize: 18, fontWeight: 500}}>{item}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Check_Texto